import React from 'react';
import dayjs from 'dayjs';

import { FORMAT } from 'constants/date-constants';

import { capitalize } from 'utils';

import { Maybe, Scalars } from 'data/__generated__';

export interface FormattedDeliveryDateProps {
    deliveryDate?: Maybe<Scalars['String']['output']>;
    shouldCapitalize?: boolean;
}

export const FormattedDeliveryDate: React.FC<FormattedDeliveryDateProps> = ({
    deliveryDate,
    shouldCapitalize = true,
}) => {
    if (!deliveryDate) {
        return 'Pas de date sélectionnée';
    }
    const now = new Date();
    const dayJsDeliveryDate = dayjs(deliveryDate, FORMAT);
    const translatedWeekday = dayJsDeliveryDate.format('dddd');
    const dateDisplayFormat = dayJsDeliveryDate.year() === now.getFullYear() ? 'D MMMM' : 'D MMMM YYYY';
    const formattedDate = `${shouldCapitalize ? capitalize(translatedWeekday) : translatedWeekday} ${dayJsDeliveryDate.format(dateDisplayFormat)}`;
    return formattedDate;
};
